import { useState } from 'react';
import PageLayout from '../components/ui/PageLayout';
import FinanceHeaderCards from '../components/finance/FinanceHeaderCards';
import FinanceFilters from '../components/finance/FinanceFilters';
import FinanceTable from '../components/finance/FinanceTable';
import FinanceDetailsDialog from '../components/finance/FinanceDetailsDialog';
import { useFinanceList } from '../hooks/queries/useFinance';
import { useProfessionals, usePlaces } from '../hooks/queries';
import { useDialog } from '../hooks/useDialog';

function defaultRange() {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth(), 1);
  return {
    startDate: first.toISOString().split('T')[0],
    endDate:   now.toISOString().split('T')[0],
    professionalId: '',
    placeId: '',
  };
}

export default function FinancePage() {
  const [filters, setFilters] = useState(defaultRange());
  const listQuery = useFinanceList(filters);
  const { items: professionalsData } = useProfessionals();
  const { items: placesData } = usePlaces();
  const professionals = Array.isArray(professionalsData) ? professionalsData : (professionalsData?.professionals || []);
  const places = Array.isArray(placesData) ? placesData : (placesData?.places || []);
  const detailsDialog = useDialog();

  return (
    <PageLayout themeKey="finance">
      <FinanceHeaderCards />
      <FinanceFilters value={filters} onChange={setFilters} professionals={professionals} places={places} />
      <FinanceTable
        response={listQuery.data}
        loading={listQuery.isLoading}
        onDetailsClick={(item) => detailsDialog.handleOpen(item)}
      />
      <FinanceDetailsDialog
        open={detailsDialog.open}
        appointmentId={detailsDialog.data?.id}
        onClose={detailsDialog.handleClose}
      />
    </PageLayout>
  );
}
